// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__OYAuj","list":"PatternAutocomplete_list__wXvHY"};